import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { MenuActionsComponent } from '@modules/shared/menu-actions/menu-actions.component';
import { SadmClient } from '@pixacare/dtos';
import { capitalize } from '@pixacare/shared';
import { MenuAction } from '@shared/models/menu-actions/menu-action';
import { TuiAppearanceOptions, TuiButton, TuiDropdown, TuiSizeL, TuiSizeS } from '@taiga-ui/core';
import { TuiChevron } from '@taiga-ui/kit';
import { SadmTypeLabelService } from '../../services/sadm-type-label.service';

@Component({
  selector: 'pxc-sadm-client-action-button',
  templateUrl: './sadm-client-action-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TuiButton, TuiDropdown, TuiChevron, MenuActionsComponent],
})
export class SadmClientActionButtonComponent {
  readonly sadmClients = input.required<SadmClient[]>();
  readonly label = input.required<string>();
  readonly icon = input<string>();
  readonly appearance = input<TuiAppearanceOptions['appearance']>('primary');
  readonly size = input<TuiSizeS | TuiSizeL>('s');
  readonly disabled = input<boolean>(false);

  readonly clientSelected = output<SadmClient>();

  private readonly sadmLabelsByType = inject(SadmTypeLabelService).sadmLabelsByType;

  readonly menuActions = computed<MenuAction[]>(() =>
    this.sadmClients().map((sadmClient) => ({
      label: sadmClient.name ?? capitalize(`${this.sadmLabelsByType[sadmClient.sadmType]}s`),
      execute: (): void => this.clientSelected.emit(sadmClient),
    })),
  );
}
